import * as _ from 'lodash';

export const getImageForVariant = (product: GQL.IProduct, variant: GQL.IProductVariant) => {
    const orderedImages = _.orderBy(
        (product.images || []).map(i => {
            return {
                ...i,
                createdAt: new Date((i as any).createdAt)
            };
        }),
        ['priority', 'createdAt'],
        ['asc']
    );

    const hasDefinitionValue = (variant.definition || {}).visual != undefined;
    if (hasDefinitionValue) {
        for (const image of orderedImages) {
            let valid = true;

            if (Array.isArray((variant.definition || {}).visual)) {
                if (image.values.length != variant.definition.visual.length) {
                    valid = false;
                }

                for (const valueId of variant.definition.visual) {
                    if (valueId != undefined) {
                        if (!image.values.some(v => v.id == valueId)) {
                            valid = false;
                            break;
                        }
                    }
                }
            } else {
                if (!image.values.some(v => v.id == (variant.definition || {}).visual)) {
                    valid = false;
                }
            }

            if (valid) {
                return image;
            }
        }
    } else {
        if (Array.isArray(orderedImages) && orderedImages.length > 0) {
            return orderedImages[0];
        }
    }

    return undefined;
};



// WEBPACK FOOTER //
// ./src/helpers/Images/getImageForVariant.ts